import ReactDOM from 'react-dom/client';

import '@fontsource-variable/open-sans';
import '@fontsource-variable/roboto-flex';

import { initializeSentry } from './lib/sentry.ts';
import App from './App.tsx';

import './index.css';

initializeSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
